/* eslint-disable no-param-reassign */
import { DOMAINS, COUNTRIES_AREAS } from '@console/store/actionTypes/homepage'

// interface IDomains {
//     'account-staging.huami.com': string,
//     'api-user-staging.huami.com': string,
//     'api-mifit-staging.huami.com': string,
//     'auth-staging.huami.com': string
// }

interface IState {
  domains: any
  areas: any // 国家地区码，包括美国的州
  countries: any // 国家码
  recommend_country: any // 推荐的国家码
}

const initialState = {
  domains: {},
  areas: [],
  countries: [],
  recommend_country: {}
}

export default function common(state: IState = initialState, { type, payload }: any) {
  switch (type) {
    case DOMAINS:
      if (payload && payload.length) {
        let domains = {}
        for (const domain of payload) {
          domains = { ...domains, [domain.host]: `https://${domain.cnames[0]}` }
        }
        state = { ...state, domains }
      } else {
        state = { ...state, domains: null }
      }
      break
    case COUNTRIES_AREAS:
      state = {
        ...state,
        areas: payload.areas,
        countries: payload.countries,
        recommend_country: payload.recommendCountry
      }
      break
    default:
      break
  }
  return state
}
